export default {
    translations: { // Mesmo valor usado nas configurações (defaultNS)
      home: {
        message: 'Hello World!'
      },
      dashboard: {
        title: 'Monitoring Upper Respiratory Infection in Primary Healthcare (PHC) in Brazil',
        subtitle: 'Overview of Upper Respiratory Infections (URI) encounters',
        queda: 'Decreasing',
        estavel: '&nbsp;&nbsp;Stable&nbsp;&nbsp;',
        alta : 'Increasing',
        data : 'Date',
        cidade : 'Municipality',
        populacao: 'Population',
        atencao: 'Attention',
        aviso: 'Warning',
        titulo_mapa_taxa_crescimento: 'Growth rate (applied to moving average) of URI encounters',
        titulo_mapa_atendimentos_excedentes : 'Exceeding URI Encounters',
        legenda_mapa_taxa_crescimento: 'Growth rate',
        legenda_mapa_atendimentos_excedentes: 'Exceeding Encounters',
        graficos: {
          titulo_mm: 'URI encounters Ratio',
          legenda_mm: {
            1:'Moving Average',
            2:'Ratio (URI encounters/Total encounters)',
          },
          titulo_variacao_mm : 'Growth Rate of URI Ratio (Moving Average)',
          titulo_atendimento_gripais : 'URI encounters in PHC',
          titulo_atendimento_totais : 'Total Encounters in PHC',
          titulo_excesso : 'Exceeding URI encounters from expected Limit',
          titulo_limite : 'URI encounters Expected Limit',
        },
        table: {
          col1: 'Municipality',
          col2: 'Population',
          col3: 'Growth Rate (URI ratio)',
          col4: 'Exceeding URI Encounters',
          col5: 'Expected limit of Encounters (URI)',
          col6: 'URI encounters Ratio',
          col7: 'URI encounters',
          col8: 'Total Encounters',
        },
        todos: 'All'
      }
    }
  }